import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Col, message, Row } from 'antd';

import { getTeacher } from 'requests/teacher';

const TeacherView = () => {
    const [teacher, setTeacher] = useState({});

    const params = useParams();
    const { t } = useTranslation();

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        try {
            const result = await getTeacher(params.id);
            setTeacher(result);
        } catch (err) {
            console.log(err);
            message.error(t(err.response?.data.message || 'error'));
        }
    };

    return (
        teacher && (
            <div className="add-teacher-content">
                {/* <div className="teacher-btn">
                    <a className="ant-btn print-btn">{t('print')}</a>
                    <a className="ant-btn download-btn">
                        <img src={download} alt="" />
                        {t('download')}
                    </a>
                </div> */}

                <div className="add-edit-form">
                    <h1 className="mt-32 mb-40" style={{ textAlign: 'center' }}>
                        ABK COLLEGE
                    </h1>
                    <div className="text">
                        <Row>
                            <Col span={8}>
                                <p>{t('student_name')}</p>
                            </Col>
                            <Col span={8}>
                                <p>{teacher.name}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={8}>
                                <p>{t('class')}</p>
                            </Col>
                            <Col span={8}>
                                <p>{teacher.classes?.map((_class) => _class.className).join(', ')}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={8}>
                                <p>{t('course')}</p>
                            </Col>
                            <Col span={8}>
                                <p>
                                    E-mail: {teacher.email} TEL: {teacher.mobile}
                                </p>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        )
    );
};

export default TeacherView;
